import { BaseEntity } from "yt-ng-framework";

export class Nacija extends BaseEntity{
    constructor(){
        super();
}

Naziv: string=null;
//datetimecr: Date;

Deserialize(input: any){
    this.ID = input.ID;
    this.Naziv = input.Naziv;
    //this.datetimecr = input.datetimecr;
    return this;
}

Serialize(input: Nacija){
    return input;
}

}
